import { useNavigate } from "react-router-dom";
import { LanguageSelector } from "@/components/LanguageSelector";
import { useLanguage } from "@/context/LanguageContext";
import { LogIn, UserPlus, Wrench } from "lucide-react";

export default function Entry() {
  const nav = useNavigate();
  const { t } = useLanguage();
  return (
    <div className="relative min-h-screen flex flex-col">
      <div className="absolute inset-0">
        <picture>
          <source srcSet="/hero-mobile.webp" media="(max-width: 767px)" />
          <source srcSet="/hero-desktop.webp" media="(min-width: 768px)" />
          <img src="/hero-desktop.webp" alt="" className="h-full w-full object-cover" />
        </picture>
        <div className="absolute inset-0 bg-primary/90" />
      </div>
      <LanguageSelector variant="onImage" />

      <div className="relative z-10 flex flex-1 flex-col items-center justify-center px-6 max-w-md mx-auto w-full text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-secondary shadow-md">
          <Wrench className="h-8 w-8 text-primary" strokeWidth={2.2} />
        </div>
        <h1 className="font-display text-5xl font-extrabold tracking-tight text-secondary mt-5">MR SHU</h1>
        <p className="text-secondary/90 text-base mt-2">{t("min_tagline")}</p>
        <p className="text-secondary/70 text-sm mt-1">Christchurch</p>

        <div className="w-full space-y-4 mt-10">
          <button data-testid="entry-login-btn" onClick={() => nav("/login")}
            className="flex w-full h-16 items-center justify-center gap-3 rounded-full bg-primary text-primary-foreground text-lg font-semibold shadow-lg border border-white/15 hover:-translate-y-1 active:scale-95 transition-transform duration-200">
            <LogIn className="h-6 w-6" /> {t("login")}
          </button>
          <button data-testid="entry-register-btn" onClick={() => nav("/register")}
            className="flex w-full h-16 items-center justify-center gap-3 rounded-full bg-accent text-accent-foreground text-lg font-semibold shadow-lg hover:-translate-y-1 active:scale-95 transition-transform duration-200">
            <UserPlus className="h-6 w-6" /> {t("register")}
          </button>
        </div>
      </div>

      <div className="relative z-10 pb-8 text-center">
        <button data-testid="entry-admin-link" onClick={() => nav("/admin/login")}
          className="text-sm text-white/70 hover:text-white transition-colors">
          {t("admin_link")}
        </button>
      </div>
    </div>
  );
}
